// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import GenerateReport from './components/GenerateReport';
import AddEmployee from './components/AddEmployee';
import Payroll from './components/PayRoll'; // Ensure correct casing
import ProjectExpense from './components/ProjectExpense';
import AddBankAccount from './components/AddBankAccount';
import UpdateBankBalance from './components/UpdateBankBalance';
import RecordIncome from './components/RecordIncome';
import ManageTransactions from './components/ManageTransactions';
import { AuthProvider } from './components/AuthContext'; // Import AuthProvider
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute
import EmployeeManagement  from "./components/EmployeeManagement";

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public Route */}
                    <Route path="/" element={<Login />} />

                    {/* Protected Routes */}
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/generate-report"
                        element={
                            <ProtectedRoute>
                                <GenerateReport />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/add-employee"
                        element={
                            <ProtectedRoute>
                                <AddEmployee />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/payroll"
                        element={
                            <ProtectedRoute>
                                <Payroll />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/project-expense"
                        element={
                            <ProtectedRoute>
                                <ProjectExpense />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/add-bank-account"
                        element={
                            <ProtectedRoute>
                                <AddBankAccount />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/update-bank-balance"
                        element={
                            <ProtectedRoute>
                                <UpdateBankBalance />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/record-income"
                        element={
                            <ProtectedRoute>
                                <RecordIncome />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/manage-transactions"
                        element={
                            <ProtectedRoute>
                                <ManageTransactions />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/employee-management"
                        element={
                            <ProtectedRoute>
                                <EmployeeManagement />
                            </ProtectedRoute>
                        }
                    />

                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;